import React, { useState, useEffect } from "react";
import Record from "./CouponsRecord.json";

import "../Styling/Coupon.css";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActions,
  CardMedia,
  Button,
  Box,
  ToggleButton,
} from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";

export default function Coup() {
  const [pop, setPop] = useState(false);
  const toggleFun = () => {
    setPop(!pop);
  };

  return (
    <>
      <br />

      <div style={{ justifyContent: "center" }}>
        <Box
          container
          spacing={3}
          sx={{
            flexWrap: "wrap",
            display: "flex",
            padding: "90px 10px 0px 10px",
          }}
        >
          {Record.map((record) => {
            return (
              <>
                <Grid key={record.code}>
                  <Card
                    sx={{
                      width: 345,
                      marginLeft: "130px",
                      marginBottom: "130px",
                      borderRadius: "10px",
                    }}
                  >
                    <CardMedia
                      sx={{ height: 200 }}
                      image={record.BrandThumbnail}
                      title={record.Offer}
                    />
                    <CardContent sx={{ height: 130 }}>
                      <Typography gutterbottom variant="h5" component="div">
                        {record.code}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {record.Offer}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <div>
                        <Button
                          onClick={toggleFun}
                          className="pop"
                          size="large"
                        >
                          Get Code
                        </Button>
                        {pop && (
                          <div className="popup">
                            <div onClick={toggleFun} className="overlay"></div>
                            <div className="pop-content">
                              <h3>YOUR CODE : </h3>
                              <h2>XYZ</h2>
                              <button className="close" onClick={toggleFun}>
                                CLOSE
                              </button>
                            </div>
                          </div>
                        )}
                      </div>

                      <Button size="small">Share</Button>
                    </CardActions>
                  </Card>
                </Grid>
              </>
            );
          })}
        </Box>
      </div>
    </>
  );
}
